import { createSlice } from "@reduxjs/toolkit";
import { getDocsList } from "./getDocList";
import { getSellersAndDeeds } from "./getSellersDeeds";
import { getFolders } from "./getFolders";
import { getFolderForms } from "./getFolderForms";
import { addFolder } from "./addFolder";
import { getPackages } from "./getPackages";
import { getPackageFiles } from "./getPackageFiles";
import { getDocDetails } from "./getDocDetails";
import { getTransactionFolders } from "./getTransactionFolders";
import { addForms } from "./addForm";
import { getHistoryDetail } from "./getFormHistory";
import { addBuyerToTransaction } from "./addBuyerToTransaction";
import { AddBuyerBroker } from "./addBuyerBroker";
import { AddSellerBroker } from "./addSellerBroker";
import { addSellerToTransaction } from "./addSellerToTransaction";
import { sendFormForSigning } from "./sendFormForSigning";
import { deleteForm } from "./addfolderapi";
import {
  updateBuyer,
  updateSeller,
  updateBuyerBroker,
  updateSellerBroker,
} from "./updateUser";
import { getFolderEnvelopes } from "./getFolderEnvelopes";
import { addChildFolder } from "./addChildFolder";
import { updateFolder } from "./updateFolder";
const initialState = {
  docs: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  sellersAnsDeeds: {
    isLoading: false,
    data: {},
    allData: {},
    success: false,
    errMsg: null,
  },
  folders: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  folderForms: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  createFolder: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  packages: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  packageFiles: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  docDetail: {
    isLoading: false,
    data: {},
    success: false,
    errMsg: null,
  },
  transactionFolders: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  addForms: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  formHistory: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  addBuyer: {
    isLoading: false,
    data: {},
    success: false,
    errMsg: null,
  },
  addSeller: {
    isLoading: false,
    data: {},
    success: false,
    errMsg: null,
  },
  sendForm: {
    isLoading: false,
    data: {},
    success: false,
    errMsg: null,
  },
  updateBuyer: {
    isLoading: false,
    data: {},
    errMsg: null,
  },
  updateSeller: {
    isLoading: false,
    data: {},
    errMsg: null,
  },
  updateBuyerBroker: {
    isLoading: false,
    data: {},
    errMsg: null,
  },
  updateSellerBroker: {
    isLoading: false,
    data: {},
    errMsg: null,
  },
  folderEnvelopes: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  childFolder: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  folderUpdate: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  addBuyerBroker: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  AddSellerBroker: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
};
const Docs = createSlice({
  name: "Docs",
  initialState,
  extraReducers: {
    // get docs list api
    [getDocsList.pending]: (state) => {
      state.docs.isLoading = true;
      state.docs.errMsg = null;
      state.docs.data = [];
    },
    [getDocsList.fulfilled]: (state, action) => {
      state.docs.isLoading = false;
      state.docs.data = action.payload;
    },
    [getDocsList.rejected]: (state, action) => {
      state.docs.isLoading = false;
      state.docs.errMsg = action.payload;
    },
    // delete form
    [deleteForm.fulfilled]: (state, action) => {
      let docsData = { ...state.docDetail.data };
      let forms = [...docsData.forms]?.filter(
        (it) => it.id !== action.payload.formId
      );
      docsData.forms = [...forms];
      state.docDetail.data = docsData;
    },
    // get sellers and deeds api
    [getSellersAndDeeds.pending]: (state) => {
      state.sellersAnsDeeds.isLoading = true;
      state.sellersAnsDeeds.errMsg = null;
    },
    [getSellersAndDeeds.fulfilled]: (state, action) => {
      state.sellersAnsDeeds.isLoading = false;
      state.sellersAnsDeeds.allData = action.payload.data;
      state.sellersAnsDeeds.data = action.payload?.data?.response?.data;
    },
    [getSellersAndDeeds.rejected]: (state, action) => {
      state.sellersAnsDeeds.isLoading = false;
      state.sellersAnsDeeds.errMsg = action.payload;
    },
    // get all folders
    [getFolders.pending]: (state) => {
      state.folders.isLoading = true;
      state.folders.errMsg = null;
    },
    [getFolders.fulfilled]: (state, action) => {
      state.folders.isLoading = false;
      state.folders.data = action.payload?.data;
    },
    [getFolders.rejected]: (state, action) => {
      state.folders.isLoading = false;
      state.folders.errMsg = action.payload;
    },
    // get  folder forms
    [getFolderForms.pending]: (state) => {
      state.folderForms.isLoading = true;
      state.folderForms.errMsg = null;
    },
    [getFolderForms.fulfilled]: (state, action) => {
      state.folderForms.isLoading = false;
      state.folderForms.data = action.payload?.data;
    },
    [getFolderForms.rejected]: (state, action) => {
      state.folderForms.isLoading = false;
      state.folderForms.errMsg = action.payload;
    },
    // addFolder
    [addFolder.pending]: (state) => {
      state.createFolder.isLoading = true;
      state.createFolder.errMsg = null;
    },
    [addFolder.fulfilled]: (state, action) => {
      state.createFolder.isLoading = false;
      state.createFolder.data = action.payload?.data;
      state.docs.data = [action.payload?.data, ...state.docs.data];
    },
    [addFolder.rejected]: (state, action) => {
      state.createFolder.isLoading = false;
      state.createFolder.errMsg = action.payload;
    },
    // get all packages
    [getPackages.pending]: (state) => {
      state.packages.isLoading = true;
      state.packages.errMsg = null;
    },
    [getPackages.fulfilled]: (state, action) => {
      state.packages.isLoading = false;
      state.packages.data = action.payload?.data;
    },
    [getPackages.rejected]: (state, action) => {
      state.packages.isLoading = false;
      state.packages.errMsg = action.payload;
    },
    //   get Packages Files
    [getPackageFiles.pending]: (state) => {
      state.folderForms.isLoading = true;
      state.folderForms.errMsg = null;
    },
    [getPackageFiles.fulfilled]: (state, action) => {
      state.folderForms.isLoading = false;
      state.folderForms.data = action.payload?.data;
    },
    [getPackageFiles.rejected]: (state, action) => {
      state.folderForms.isLoading = false;
      state.folderForms.errMsg = action.payload;
    },
    //   doc Detail
    [getDocDetails.pending]: (state) => {
      state.docDetail.isLoading = true;
      state.docDetail.errMsg = null;
    },
    [getDocDetails.fulfilled]: (state, action) => {
      state.docDetail.isLoading = false;
      state.docDetail.data = action.payload?.data;
    },
    [getDocDetails.rejected]: (state, action) => {
      state.docDetail.isLoading = false;
      state.docDetail.errMsg = action.payload;
    },
    //   get Transaction folders
    [getTransactionFolders.pending]: (state) => {
      state.transactionFolders.isLoading = true;
      state.transactionFolders.errMsg = null;
    },
    [getTransactionFolders.fulfilled]: (state, action) => {
      state.transactionFolders.isLoading = false;
      state.transactionFolders.data = action.payload?.data;
    },
    [getTransactionFolders.rejected]: (state, action) => {
      state.transactionFolders.isLoading = false;
      state.transactionFolders.errMsg = action.payload;
    },
    //   get Transaction folders
    [addForms.pending]: (state) => {
      state.addForms.isLoading = true;
      state.addForms.errMsg = null;
    },
    [addForms.fulfilled]: (state, action) => {
      state.addForms.isLoading = false;
      state.addForms.data = action.payload?.data;
    },
    [addForms.rejected]: (state, action) => {
      state.addForms.isLoading = false;
      state.addForms.errMsg = action.payload;
    },
    //   get form history
    [getHistoryDetail.pending]: (state) => {
      state.formHistory.isLoading = true;
      state.formHistory.errMsg = null;
    },
    [getHistoryDetail.fulfilled]: (state, action) => {
      state.formHistory.isLoading = false;
      state.formHistory.data = action.payload?.data;
    },
    [getHistoryDetail.rejected]: (state, action) => {
      state.formHistory.isLoading = false;
      state.formHistory.errMsg = action.payload;
    },
    //   add buyer into transaction
    [addBuyerToTransaction.pending]: (state) => {
      state.addBuyer.isLoading = true;
      state.addBuyer.errMsg = null;
    },
    [addBuyerToTransaction.fulfilled]: (state, action) => {
      state.addBuyer.isLoading = false;
      state.addBuyer.data = action.payload?.data;
      let docsData = { ...state.docDetail.data };
      docsData.buyers = [...docsData.buyers, action.payload?.data];
      state.docDetail.data = docsData;
    },
    [addBuyerToTransaction.rejected]: (state, action) => {
      state.addBuyer.isLoading = false;
      state.addBuyer.errMsg = action.payload;
    },
    //   add buyer broker into transaction
    [AddBuyerBroker.pending]: (state) => {
      state.addBuyerBroker.isLoading = true;
      state.addBuyerBroker.errMsg = null;
    },
    [AddBuyerBroker.fulfilled]: (state, action) => {
      state.addBuyerBroker.isLoading = false;
      state.addBuyerBroker.data = action.payload?.data;
      let docsData = { ...state.docDetail.data };
      docsData.buyer_brokers = [
        ...docsData.buyer_brokers,
        action.payload?.data,
      ];
      state.docDetail.data = docsData;
    },
    [AddBuyerBroker.rejected]: (state, action) => {
      state.addBuyerBroker.isLoading = false;
      state.addBuyerBroker.errMsg = action.payload;
    },
    //   add seller into transaction
    [addSellerToTransaction.pending]: (state) => {
      state.addSeller.isLoading = true;
      state.addSeller.errMsg = null;
    },
    [addSellerToTransaction.fulfilled]: (state, action) => {
      state.addSeller.isLoading = false;
      state.addSeller.data = action.payload?.data;
      let docsData = { ...state.docDetail.data };
      docsData.sellers = [...docsData.sellers, action.payload?.data];
      state.docDetail.data = docsData;
    },
    [addSellerToTransaction.rejected]: (state, action) => {
      state.addSeller.isLoading = false;
      state.addSeller.errMsg = action.payload;
    },
    //   add seller broker into transaction
    [AddSellerBroker.pending]: (state) => {
      state.AddSellerBroker.isLoading = true;
      state.AddSellerBroker.errMsg = null;
    },
    [AddSellerBroker.fulfilled]: (state, action) => {
      state.AddSellerBroker.isLoading = false;
      state.AddSellerBroker.data = action.payload?.data;
      let docsData = { ...state.docDetail.data };
      docsData.seller_brokers = [
        ...docsData.seller_brokers,
        action.payload?.data,
      ];
      state.docDetail.data = docsData;
    },
    [AddSellerBroker.rejected]: (state, action) => {
      state.AddSellerBroker.isLoading = false;
      state.AddSellerBroker.errMsg = action.payload;
    },
    //  send form for signing purpose
    [sendFormForSigning.pending]: (state) => {
      state.sendForm.isLoading = true;
      state.sendForm.errMsg = null;
    },
    [sendFormForSigning.fulfilled]: (state, action) => {
      state.sendForm.isLoading = false;
      state.sendForm.data = action.payload?.data;
      state.sendForm.errMsg = null;
    },
    [sendFormForSigning.rejected]: (state, action) => {
      state.sendForm.isLoading = false;
      state.sendForm.errMsg = action.payload;
    },
    //  update buyer
    [updateBuyer.pending]: (state) => {
      state.updateBuyer.isLoading = true;
      state.updateBuyer.errMsg = null;
    },
    [updateBuyer.fulfilled]: (state, action) => {
      state.updateBuyer.isLoading = false;
      state.updateBuyer.data = action.payload?.data;
      state.updateBuyer.errMsg = null;
      let docsData = { ...state.docDetail.data };
      let buyers = [...docsData.buyers];
      let index = buyers?.findIndex((it) => it.id === action.payload.data.id);
      buyers[index] = { ...buyers[index], ...action.payload?.data };
      docsData.buyers = [...buyers];
      state.docDetail.data = docsData;
    },
    [updateBuyer.rejected]: (state, action) => {
      state.updateBuyer.isLoading = false;
      state.updateBuyer.errMsg = action.payload;
    },
    //  update seller
    [updateSeller.pending]: (state) => {
      state.updateSeller.isLoading = true;
      state.updateSeller.errMsg = null;
    },
    [updateSeller.fulfilled]: (state, action) => {
      state.updateSeller.isLoading = false;
      state.updateSeller.data = action.payload?.data;
      state.updateSeller.errMsg = null;
      let docsData = { ...state.docDetail.data };
      let sellers = [...docsData.sellers];
      let index = sellers?.findIndex((it) => it.id === action.payload.data.id);
      sellers[index] = { ...sellers[index], ...action.payload?.data };
      docsData.sellers = [...sellers];
      state.docDetail.data = docsData;
    },
    [updateSeller.rejected]: (state, action) => {
      state.updateSeller.isLoading = false;
      state.updateSeller.errMsg = action.payload;
    },
    //  update seller broker
    [updateSellerBroker.pending]: (state) => {
      state.updateSellerBroker.isLoading = true;
      state.updateSellerBroker.errMsg = null;
    },
    [updateSellerBroker.fulfilled]: (state, action) => {
      state.updateSellerBroker.isLoading = false;
      state.updateSellerBroker.data = action.payload?.data;
      state.updateSellerBroker.errMsg = null;
      let docsData = { ...state.docDetail.data };
      let sellers = [...docsData.seller_brokers];
      let index = sellers?.findIndex((it) => it.id === action.payload.data.id);
      sellers[index] = { ...sellers[index], ...action.payload?.data };
      docsData.seller_brokers = [...sellers];
      state.docDetail.data = docsData;
    },
    [updateSellerBroker.rejected]: (state, action) => {
      state.updateSellerBroker.isLoading = false;
      state.updateSellerBroker.errMsg = action.payload;
    },
    //  update buyer broker
    [updateBuyerBroker.pending]: (state) => {
      state.updateBuyerBroker.isLoading = true;
      state.updateBuyerBroker.errMsg = null;
    },
    [updateBuyerBroker.fulfilled]: (state, action) => {
      state.updateSellerBroker.isLoading = false;
      state.updateSellerBroker.data = action.payload?.data;
      state.updateSellerBroker.errMsg = null;
      let docsData = { ...state.docDetail.data };
      let buyers = [...docsData.buyer_brokers];
      let index = buyers?.findIndex((it) => it.id === action.payload.data.id);
      buyers[index] = { ...buyers[index], ...action.payload?.data };
      docsData.buyer_brokers = [...buyers];
      state.docDetail.data = docsData;
    },
    [updateBuyerBroker.rejected]: (state, action) => {
      state.updateBuyerBroker.isLoading = false;
      state.updateBuyerBroker.errMsg = action.payload;
    },
    //  get folder envelopes
    [getFolderEnvelopes.pending]: (state) => {
      state.folderEnvelopes.isLoading = true;
      state.folderEnvelopes.errMsg = null;
    },
    [getFolderEnvelopes.fulfilled]: (state, action) => {
      state.folderEnvelopes.isLoading = false;
      state.folderEnvelopes.data = action.payload;
      state.folderEnvelopes.errMsg = null;
    },
    [getFolderEnvelopes.rejected]: (state, action) => {
      state.folderEnvelopes.isLoading = false;
      state.folderEnvelopes.errMsg = action.payload;
    },
    //  add child folder
    [addChildFolder.pending]: (state) => {
      state.childFolder.isLoading = true;
      state.childFolder.errMsg = null;
    },
    [addChildFolder.fulfilled]: (state, action) => {
      state.childFolder.isLoading = false;
      state.childFolder.data = action.payload?.data;
      state.docs.data = [
        { ...action.payload.data, type: "folder" },
        ...state.docs.data,
      ];
    },
    [addChildFolder.rejected]: (state, action) => {
      state.childFolder.isLoading = false;
      state.childFolder.errMsg = action.payload;
    },
    //  rename folder
    [updateFolder.pending]: (state) => {
      state.folderUpdate.isLoading = true;
      state.folderUpdate.errMsg = null;
    },
    [updateFolder.fulfilled]: (state, action) => {
      state.folderUpdate.isLoading = false;
      state.folderUpdate.data = action.payload?.data;
      state.docs.data = state.docs.data.map((it) =>
        it.id === action.payload?.data.id && it.type === "folder"
          ? { ...it, ...action.payload?.data }
          : it
      );
    },
    [updateFolder.rejected]: (state, action) => {
      state.folderUpdate.isLoading = false;
      state.folderUpdate.errMsg = action.payload;
    },
  },
});

export default Docs.reducer;
export * from "./getSellersDeeds";
export * from "./getDocList";
export * from "./getFolders";
export * from "./getFolderForms";
export * from "./addFolder";
export * from "./getPackages";
export * from "./getPackageFiles";
export * from "./getDocDetails";
export * from "./getTransactionFolders";
export * from "./addForm";
export * from "./getFormHistory";
export * from "./addBuyerToTransaction";
export * from "./addSellerToTransaction";
export * from "./addBuyerBroker";
export * from "./addSellerBroker";
export * from "./sendFormForSigning";
export * from "./updateUser";
export * from "./libraries";
export * from "./addChildFolder";
export * from "./updateFolder";
